import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import { resolvePath } from "@utils/resolvePath";
import CloneChildren from "@components/children";
import {
  PlanCardContainer,
  TopSection,
  BackgroundVideo,
  OverlayText,
  PlanDetails,
  PlanName,
  PlanDescription,
  PlanPrice,
  CtaButton,
  DescriptionPrice,
  InfoCTA,
  PriceWrapper,
  StrikethroughPrice,
  PseudoDiscount
} from "./styles";
import styled from "styled-components";
import AckoLogoBig from "@public/images/dashcam/AckoLogoHalfBig.svg";
import AckoLogoSmall from "@public/images/dashcam/AckoLogoHalfSmall.svg";

const GradientBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(114deg, #fff 18.91%, #e3d5fe 125.24%);
  z-index: 1;
  border-radius: 24px 24px 0px 0px;
`;

export interface IPlanCardV2 extends CommonProps {
  planId?: string;
  planName?: string;
  description?: string;
  premium?: string;
  overlayText?: string;
  ctaText?: string;
  subText?: string;
  children?: any;
  isDashcamPlan?: boolean;
  strikeOffPrice?: string;
  pseudoDiscount?: string;
  actions?: any;
  is_disabled?: boolean;
  garageType?: string;
  isVariant?: boolean;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const PlanCardV2 = ({ children, ...props }: IPlanCardV2) => {
  const {
    is_visible,
    planName,
    premium,
    overlayText,
    subText,
    ctaText,
    styles,
    id,
    isDashcamPlan,
    strikeOffPrice,
    pseudoDiscount,
    actions,
    is_disabled,
    garageType,
    isVariant
  } = props;
  const { on_select_plan_click } = actions || {};
  const handleClick = () => {
    if (on_select_plan_click?.length > 0) {
      on_select_plan_click.forEach((eachFunc: any) => {
        eachFunc.funCall(eachFunc.args);
      });
    }
  };
  if (is_disabled) return <></>;
  return (id && is_visible) || !id ? (
    <PlanCardContainer styles={styles}>
      <TopSection isDashcamPlan={isDashcamPlan}>
        {isDashcamPlan ? (
          <BackgroundVideo>
            <video
              autoPlay
              muted
              loop
              playsInline
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1
              }}
            >
              <source
                src={resolvePath("/images/dashcam/DashcamVideo.mp4")}
                type="video/mp4"
              />
            </video>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(10, 19, 20, 0.50)",
                zIndex: 2
              }}
            />
          </BackgroundVideo>
        ) : (
          <>
            <GradientBackground />
            <AckoLogoBig
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 2,
                width: "157.353px",
                height: "121.001px"
              }}
            />
            <AckoLogoSmall
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                marginBottom: "20px",
                zIndex: 2
              }}
            />
          </>
        )}
        {isDashcamPlan && <OverlayText>{overlayText}</OverlayText>}
        <PlanDetails>
          {garageType && isVariant ? (
            <PlanName>{garageType}</PlanName>
          ) : (
            <PlanName isDashcamPlan={isDashcamPlan}>{planName}</PlanName>
          )}
          <InfoCTA>
            <DescriptionPrice>
              <PlanDescription isDashcamPlan={isDashcamPlan}>
                {subText}
              </PlanDescription>
              <PriceWrapper>
                <PlanPrice isDashcamPlan={isDashcamPlan}> ₹{premium}</PlanPrice>
                {strikeOffPrice && (
                  <StrikethroughPrice>₹{strikeOffPrice}</StrikethroughPrice>
                )}
                {pseudoDiscount && (
                  <PseudoDiscount>{pseudoDiscount}</PseudoDiscount>
                )}
              </PriceWrapper>
            </DescriptionPrice>
            <CtaButton onClick={handleClick}>{ctaText}</CtaButton>
          </InfoCTA>
        </PlanDetails>
      </TopSection>

      {children && <CloneChildren>{children}</CloneChildren>}
    </PlanCardContainer>
  ) : null;
};

export default connect(mapStateToProps)(PlanCardV2);
